<template>
    <PageView>
        <a-card title="列表">
            <a-button type="primary" slot="extra" @click="$router.push({ name: `GoodscatsEdit` })">添加分类</a-button>
            <a-table
                :loading="loading"
                :columns="columns"
                :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }"
                @change="changePagination"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
        </a-card>
    </PageView>
</template>

<script type="text/jsx">
import GoodsCats from '../../api/GoodsCats.js'
export default {
    name: 'GoodscatsList',
    data () {
        return {
            loading: true,
            columns: [
                {
                    title: '名称',
                    dataIndex: 'name',
                    customRender: (v) => <a>{v}</a>
                },
                {
                    title: '简介',
                    dataIndex: 'title',
                    customRender: (v) => <a>{v}</a>
                },
                {
                    title: '图片',
                    dataIndex: 'img',
                    customRender: (v) => {
                        return v ? <img src={v} style="width:100px;height:100px;cursor: pointer" alt="" onClick={() => {
                            this.visible = true;
                            this.viewImg = v;
                        }
                        } /> : '暂无'
                    }
                },
                {
                    title: '排序',
                    dataIndex: 'sort',
                    customRender: (v) => <a>{v}</a>
                },
             
                {
                    title: '添加时间',
                    dataIndex: 'add_time',
                    customRender: (v) => this.timeOne(v)
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-dropdown>
                                <a-menu slot="overlay">
                                    <a-menu-item onClick={() => {
                                        this.changeBanner(v.id,"deleteGoodsCats","删除")
                                    }}>删除
                                    </a-menu-item>
                                    <a-menu-item onClick={() => {
                                        this.$router.push({name:`GoodscatsEdit`,query: { id: v.id,data:v }})
                                    }}>编辑
                                    </a-menu-item>
                                </a-menu>
                                <a-button>操作 <a-icon type="down"/></a-button>
                            </a-dropdown>
                        )
                    }
                }
            ],
            data: [],
            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
        }
    },
    activated () {
        this.getList()
    },
    methods: {
        getList () {
            this.loading = true
           GoodsCats.GoodsCatsList({
                page: this.current,
                num: this.pageSize,
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key }
                })
                this.loading = false
                this.total = parseInt(res.count)
            })
        },
        changePagination (pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getList()
        },
        changeBanner (id,methods,title) {
            this.$confirm({
                title: `${title}`,
                content: `确定要${title}此分类吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        GoodsCats[methods]({ id }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}
</style>
